import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import PriceSubscriptionService from '../../services/subscriptions/PriceUpdateSubscriptionService';
export var initSubscribePrices = function initSubscribePrices(callback, instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, instrument, user;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), instrument = _getState.apexCore.instrument, user = _getState.user;
              PriceSubscriptionService.initSubscription({
                InstrumentId: instrumentId ? instrumentId : instrument.selectedInstrumentId,
                OMSId: user.userInfo.OMSId
              }, callback);
            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var ADD_PRICE = 'ADD_PRICE';
export var addPrice = function addPrice(payload) {
  return {
    type: ADD_PRICE,
    payload: payload
  };
};
export var FETCHING_ACCOUNT_CREDIT_TIERS = 'FETCHING_ACCOUNT_CREDIT_TIERS';
export var FETCH_ACCOUNT_CREDIT_TIERS_ERROR = 'FETCH_ACCOUNT_CREDIT_TIERS_ERROR';
export var fetchingAccountCreditTiers = {
  type: FETCHING_ACCOUNT_CREDIT_TIERS
};
export var fetchAccountCreditTiersError = function fetchAccountCreditTiersError(payload) {
  return {
    type: FETCH_ACCOUNT_CREDIT_TIERS_ERROR,
    payload: payload
  };
};
export var RECEIVE_ACCOUNT_CREDIT_TIERS = 'RECEIVE_ACCOUNT_CREDIT_TIERS';
export var receiveAccountCreditTiers = function receiveAccountCreditTiers(payload) {
  return {
    type: RECEIVE_ACCOUNT_CREDIT_TIERS,
    payload: payload
  };
};
export var getCreditTiers = function getCreditTiers() {
  var AccountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var Level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var payload, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingAccountCreditTiers);
              payload = {
                OMSId: getState().user.userInfo.OMSId,
                Level: Level,
                AccountId: AccountId
              };
              _context2.next = 4;
              return dispatch(callAPI('GetCreditTiers', payload));
            case 4:
              data = _context2.sent;
              if (!data) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt('return', dispatch(receiveAccountCreditTiers(data)));
            case 7:
              return _context2.abrupt('return', dispatch(fetchAccountCreditTiersError(data.errormsg)));
            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};